import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { DisplayType } from "common/components/tooltip/types";
import { Directions } from "common/components/drop-menu/types";
export function template() {
  const {
    buckets,
    tooltipErrorMsg
  } = this.state;
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx(DropMenuEl, { attrs: {
    open: true,
    direction: Directions.Down
  }, on: {
    change: this.helpers.menuChange
  }, props: {
    positionParent: this
  }, "data-sentry-element": "DropMenuEl", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-header" }, tooltipErrorMsg && /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    "always-show": true,
    "hide-arrow": true,
    type: DisplayType.Error
  } }, tooltipErrorMsg), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-title" }, this.attr("header")), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-selection-row" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-label" }, t("query-builder.retention.interval.custom-menu.bracket-by")), /* @__PURE__ */ jsx(SelectEl, { attrs: this.helpers.getUnitSelectorAttrs(), on: {
    change: this.helpers.handleChangeUnitSelector
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }))), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-content-wrapper" }, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-content" }, buckets.map((bucket, index) => {
    var _bucket$interval;
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-label" }, t("query-builder.retention.interval.custom-menu.bracket-number", {
      number: index + 1
    })), /* @__PURE__ */ jsx(InputEl, { sel: ".mp-bucket-size-input", attrs: {
      type: "number",
      "auto-focus": index === 0,
      "validation-status": this.helpers.isBucketValid(index) ? "" : "invalid",
      min: "0"
    }, on: {
      input: (ev) => this.helpers.changeBracketIntervalInput(ev, index)
    }, hook: {
      insert: (vnode) => this.helpers.insertBucketSizeInput(vnode, index)
    }, props: {
      value: ((_bucket$interval = bucket.interval) === null || _bucket$interval === void 0 ? void 0 : _bucket$interval.toString()) || ""
    } }), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-label.mp-bucket-size-label-unit" }, bucket.label), !this.helpers.isBucketValid(index) && /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-error-message" }, bucket.errorMsg));
  }))), /* @__PURE__ */ jsx("div", { sel: ".mp-bucket-size-button-row" }, /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Secondary
  }, on: {
    click: this.helpers.cancelBucketSizes
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Cancel"), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    theme: ButtonTheme.Primary,
    disabled: !!tooltipErrorMsg || buckets.length === 1
  }, on: {
    click: this.helpers.applyBucketSizes
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, "Apply"))));
}
